import TopicView from "@/marketing/views/TopicView.vue";
import PublicationView from "@/marketing/views/PublicationView.vue";
import PerformanceView from "@/marketing/views/PerformanceView.vue";
import SettingsView from "@/marketing/views/SettingsView.vue";
import ConnectionView from "@/marketing/views/ConnectionView.vue";

export const marketingRoutes = [
  {
    path: "/marketing",
    name: "Marketing",
    component: TopicView,
  },
  {
    path: "/marketing-publications",
    name: "MarketingPublications",
    component: PublicationView,
  },
  {
    path: "/marketing-performance",
    name: "MarketingPerformance",
    component: PerformanceView,
  },
  {
    path: "/marketing-connections",
    name: "MarketingConnections",
    component: ConnectionView,
  },
  {
    path: "/marketing-settings",
    name: "MarketingSettings",
    component: SettingsView,
  },
];
